module.exports = __webpack_public_path__ + "static/img/home.05d6173c.png";